<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.384 12.68A.5.5 0 006 12.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-4a.5.5 0 00-.384.18L8.5 15.219l-2.116-2.54z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
